import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table';
import { Box, Paper, Switch, Typography } from '@mui/material';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { identifier } from 'stylis';
import { useAuth } from 'AuthContext';


const BusinessUser = () => {
  const navigate = useNavigate()
  const [isApiLoading, setIsApiLoading] = React.useState(true)
  const [businessData, setBusinessData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // const [order, setOrder] = React.useState('asc');
  // const [orderBy, setOrderBy] = React.useState('');

  const columns = [
    { id: 'firstName', label: 'Name', isSorting: true, sortDirection: 'asc' },
    { id: 'email', label: 'Email', isSorting: true, sortDirection: 'asc' },
    {
      id: 'isBusinessLive',
      label: 'Live Status',
      isSorting: true,
      sortDirection: 'asc',
      render: (row) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Switch
            checked={row.isBusinessLive}
            onChange={(event, checked) => {
              if (!row.isActivated) {
                // Show notification instead of changing status
                toast.error('Please activate the user first');
                return;
              }
              handleIsLiveStatus(row._id, checked);
            }}
            color="primary"
          />
          <Typography variant="caption" fontWeight="medium">
            {row.isBusinessLive ? 'Live' : 'Offline'}
          </Typography>
        </Box>
      ),
    },
    {
      id: 'isActivated',
      label: 'Status',
      isSorting: true, sortDirection: 'asc',
      render: (row) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Switch checked={row.isActivated} onChange={(i, b) => {
            if (!b && row.isActivated) {
              // If switching from active to inactive, turn off Live status
              handleIsLiveStatus(row._id, false);
            }
            handleChangeStatus(row._id, b)
          }} />
          <Typography variant="caption" fontWeight="bold">{row.isActivated ? 'Active' : 'Inactive'}</Typography>
        </Box>
      ),
    },
    {
      id: 'action',
      label: 'Action',
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'View Dashboard', onClick: () => viewBusiness(row._id) },
            { label: 'Edit', onClick: () => navigate(`/admin/edit-bussiness-user/${row._id}`) },
            { label: 'Detail', onClick: () => navigate(`/admin/detail-business-user/${row._id}?businessId=${row.businessId}`) },
            { label: 'Remove', onClick: () => deleteBusinessUser(row._id) },
          ]}
        />
      ),
    },
  ];
  const getBusinessDetail = async () => {
    setIsApiLoading(true)
    try {
      const response = await service.users.view({ userType: 'BUSINESS', searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection });
      if (response?.data?.data) {
        setBusinessData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
    setIsApiLoading(false)
  };



  React.useEffect(() => {
    getBusinessDetail();
  }, [search, page, rowsPerPage, sortValue]);


  // const handleRequestSort = (_, property) => {
  //   const isAsc = orderBy === property && order === 'asc';
  //   setOrder(isAsc ? 'desc' : 'asc');
  //   setOrderBy(property);
  // };

  const deleteBusinessUser = async (id) => {
    try {
      let response = await service.users.edit(id, { isDeleted: true })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getBusinessDetail()
      } else {
        toast.error(response?.data?.message)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }

  const handleChangeStatus = async (id, type) => {
    try {
      let response = await service.users.edit(id, { isActivated: type })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getBusinessDetail()
      } else {
        toast.error(response?.data?.message)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
  const handleIsLiveStatus = async (id, type) => {
    try {
      let response = await service.users.edit(id, { isBusinessLive: type })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getBusinessDetail()
      } else {
        toast.error(response?.data?.message)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
  const viewBusiness = async (id) => {
    try {
      const response = await service.users.getAuthById(id);
      localStorage.setItem('tempscope', '1')
      localStorage.setItem('tempid', localStorage.getItem('id'))
      localStorage.setItem('temprememberMeEmail', localStorage.getItem('rememberMeEmail'))
      localStorage.setItem('temprememberMePassword', localStorage.getItem('rememberMePassword'))
      localStorage.setItem('temptoken', localStorage.getItem('token'))
      localStorage.setItem('tempinfo', localStorage.getItem('info'))
      localStorage.setItem('scope', '2')
      localStorage.setItem('id', response.data.data._id)
      localStorage.setItem('token', response.data.token)
      localStorage.setItem('info', JSON.stringify(response.data.data))
      // navigate('/')
      window.location.reload();
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper className="glassmorphism-card" sx={{ padding: 2, mt: '15px' }}>
        <CustomTable
          title="Business List"
          columns={columns}
          rows={businessData?.data}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isApiLoading={isApiLoading}
          // order={order}
          // orderBy={orderBy}
          // onRequestSort={handleRequestSort}
          onRequestSort={(id, direction) => {
            setSortValue({ sortKey: id, sortDirection: direction })

          }}
          totalPages={businessData?.pagination?.totalItems}
        />
      </Paper>
    </DashboardLayout>
  );
};

export default BusinessUser;
